module.exports = __webpack_public_path__ + "media/images/small-circle-teal-12990c5cf0eaeb5ad5d18d2a071fc9f2.svg";